export const sidebarConfig = {
    sections: [
        {
            title: 'OVERVIEW',
            items: [
                {
                    path: '/',
                    label: 'Dashboard',
                    icon: 'fas fa-home',
                    exact: true
                }
            ]
        },
        {
            title: 'MANAGEMENT',
            items: [
                {
                    label: 'Job Enquiries',
                    icon: 'fas fa-file-alt',
                    path: '/job_enquiries',
                    exact: true,
                    permissions: ['view job orders', 'view job order lpos'],
                },
                {
                    label: 'Sales',
                    permissions: ['view sales'],
                    icon: 'fas fa-store',
                    submenu: [
                        {
                            path: '/production_charges',
                            label: 'Production Charges',
                            exact: true,
                            permissions: ['view production charges'],
                        },
                        {
                            path: '/tailors',
                            label: 'Tailors',
                            exact: true,
                            permissions: ['view tailors'],
                        },
                        {
                            path: '/cutting_masters',
                            label: 'Cutting Masters',
                            exact: true,
                            permissions: ['view cutting masters'],
                        },
                        {
                            path: '/job_orders',
                            label: 'Job Orders',
                            exact: false,
                            permissions: ['view job orders'],
                        },
                        {
                            path: '/job_order_lpos',
                            label: 'Job Order By LPO',
                            exact: false,
                            permissions: ['view job order lpos'],
                        },
                        {
                            path: '/stock_issues',
                            label: 'Stock Issues',
                            exact: false,
                            otherActivePaths: ['/stock_issues/create', '/stock_issues/edit/*'],
                            permissions: ['view stock issues'],
                        },
                        {
                            path: '/daily_productions',
                            label: 'Daily Production',
                            exact: true,
                            permissions: ['view daily productions'],
                        },
                        {
                            path: '/produced_items',
                            label: 'Produced Items',
                            exact: true,
                            permissions: ['view produced items'],
                        },
                        {
                            path: '/job_costings',
                            label: 'Job Costings',
                            exact: false,
                            otherActivePaths: ['/job_costings/create', '/job_costings/edit/*'],
                            permissions: ['view job costings'],
                        },
                        {
                            path: '/cash_memos',
                            label: 'Cash Memos',
                            exact: false,
                            otherActivePaths: ['/cash_memos/create', '/cash_memos/edit/*'],
                            permissions: ['view cash memos'],
                        },
                        {
                            path: '/cash_memo_directs',
                            label: 'Cash Memo Directs',
                            exact: false,
                            otherActivePaths: ['/cash_memo_directs/create', '/cash_memo_directs/edit/*'],
                            permissions: ['view cash memo directs'],
                        },
                        {
                            path: '/delivery_notes',
                            label: 'Delivery Notes',
                            exact: false,
                            otherActivePaths: ['/delivery_notes/create', '/delivery_notes/edit/*'],
                            permissions: ['view delivery notes'],
                        },
                        {
                            path: '/sale_invoices',
                            label: 'Sale Invoices',
                            exact: false,
                            otherActivePaths: ['/sale_invoices/create', '/sale_invoices/edit/*'],
                            permissions: ['view sale invoices'],
                        }
                    ]
                },
                // {
                //     label: 'Receivables',
                //     icon: 'fas fa-hand-holding-usd',
                //     submenu: [
                //       {
                //         path: '/cash_receipts',
                //         label: 'Cash Receipt',
                //         exact: false,
                //         otherActivePaths: ['/cash_receipts/create', '/cash_receipts/edit/*']
                //       }
                //     ]
                // },
                {
                    label: 'Purchase',
                    icon: 'fas fa-cart-shopping',
                    permissions: ['view purchase'],
                    submenu: [
                        {
                            path: '/categories',
                            label: 'Categories',
                            exact: true,
                            permissions: ['view categories'],
                        },
                        {
                            path: '/sub_categories',
                            label: 'Sub Categories',
                            exact: true,
                            permissions: ['view sub categories'],
                        },
                        {
                            path: '/items',
                            label: 'Items',
                            exact: true,
                            permissions: ['view items'],
                        },
                        {
                            path: '/suppliers',
                            label: 'Suppliers',
                            exact: true,
                            permissions: ['view suppliers'],
                        },
                        {
                            path: '/purchase_invoices',
                            label: 'Purchase Invoices',
                            exact: false,
                            otherActivePaths: ['/purchase_invoices/create', '/purchase_invoices/edit/*'],
                            permissions: ['view purchase invoices'],
                        },
                        {
                            path: '/stock_adjustments',
                            label: 'Stock Adjustments',
                            exact: true,
                            permissions: ['view stock adjustments'],
                        },
                    ]
                },
                {
                    label: 'Customers',
                    icon: 'fas fa-users',
                    permissions: ['view customers', 'create customers'],
                    submenu: [
                        {
                            path: '/customers',
                            label: 'Customers',
                            exact: true,
                            permissions: ['view customers'],
                        },
                        {
                            path: '/customers/create',
                            label: 'Add Customer',
                            exact: false,
                            otherActivePaths: ['/customers/edit/*'],
                            permissions: ['create customers'],
                        }
                    ]
                },
                {
                    label: 'Reports',
                    icon: 'fas fa-chart-line',
                    permissions: ['view reports'],
                    submenu: [
                        {
                            path: '/report-purchase-register',
                            label: 'Purchase Register',
                            exact: true,
                            permissions: ['report purchase register'],
                        },
                        {
                            path: '/report-order-status',
                            label: 'Job Order Status',
                            exact: true,
                            permissions: ['report joborder status'],
                        },
                        {
                            path: '/report-item-production',
                            label: 'Item Wise Production',
                            exact: true,
                            permissions: ['report item production'],
                        },
                        {
                            path: '/report-item-production-costing',
                            label: 'Item Wise Production Costing',
                            exact: true,
                            permissions: ['report item production costing'],
                        },
                        {
                            path: '/report-tailor-work',
                            label: 'Tailor Wise Piece Work Card',
                            exact: true,
                            permissions: ['report tailor work'],
                        },
                        {
                            path: '/report-job-order-customer-location',
                            label: 'Job Order Register by Customer Location',
                            exact: true,
                            permissions: ['report joborder customer location'],
                        },
                        {
                            path: '/report-job-order',
                            label: 'Job Order Register',
                            exact: true,
                            permissions: ['report joborder register'],
                        },
                        {
                            path: '/report-delivery-note',
                            label: 'Delivery Note Register',
                            exact: true,
                            permissions: ['report delivery note register'],
                        },
                        {
                            path: '/report-stock-ledger',
                            label: 'Stock Ledger Summary',
                            exact: true,
                            permissions: ['report stock ledger'],
                        },
                        {
                            path: '/report-item-ledger',
                            label: 'Item Ledger',
                            exact: true,
                            permissions: ['report item ledger'],
                        },
                        {
                            path: '/report-sales',
                            label: 'Sales Report',
                            exact: true,
                            permissions: ['report sales'],
                        },
                        {
                            path: '/report-daily-transactions',
                            label: 'Daily Transactions',
                            exact: true,
                            permissions: ['report daily transactions'],
                        },
                        {
                            path: '/report-monthly-performance',
                            label: 'Monthly Performance Report',
                            exact: true,
                            permissions: ['report monthly performance'],
                        },
                        {
                            path: '/report-job-order-reversal',
                            label: 'Job Order Reversal Report',
                            exact: true,
                            permissions: ['report joborder reversal'],
                        },
                    ]
                },
                {
                    label: 'Settings',
                    icon: 'fas fa-gear',
                    permissions: ['view settings'],
                    submenu: [
                        {
                            path: '/general_settings',
                            label: 'Site Settings',
                            exact: true,
                            permissions: ['view settings'],
                        },
                        {
                            path: '/currencies',
                            label: 'Currencies',
                            exact: true,
                            permissions: ['view currencies', 'update currencies'],
                        },
                        {
                            path: '/locations',
                            label: 'Locations',
                            exact: true,
                            permissions: ['view locations', 'update locations'],
                        },
                        {
                            path: '/customer_locations',
                            label: 'Customer Locations',
                            exact: true,
                            permissions: ['view locations', 'update locations'],
                        },
                        {
                            path: '/measurement_units',
                            label: 'Measurement Units',
                            exact: true,
                            permissions: ['view mesurment units', 'update mesurment units'],
                        },
                        {
                            path: '/posting_groups',
                            label: 'Posting Groups',
                            exact: true,
                            permissions: ['view posting groups', 'update posting groups'],
                        },
                        {
                            path: '/vat_groups',
                            label: 'VAT Groups',
                            exact: true,
                            permissions: ['view vat groups', 'update vat groups'],
                        },
                        {
                            path: '/xero_settings',
                            label: 'Xero Settings',
                            exact: true,
                            permissions: ['view xero settings', 'update xero settings'],
                        },
                        {
                            path: '/zoho_settings',
                            label: 'Zoho Settings',
                            exact: true,
                            permissions: ['view zoho settings', 'update zoho settings'],
                        },

                        {
                            path: '/admin/roles',
                            label: 'Role Settings',
                            exact: true,
                            permissions: ['view roles', 'update roles'],

                        },
                        {
                            path: '/admin/users',
                            label: 'User Settings',
                            exact: true,
                            permissions: ['view users', 'update users'],
                        },
                    ]
                },
                // {
                //   label: 'Push Notifications',
                //   icon: 'fas fa-bell',
                //   submenu: [
                //     {
                //       path: '/notifications',
                //       label: 'List Notifications',
                //       exact: true
                //     }
                //   ]
                // }
            ]
        }
    ]
};

export const isActivePath = (currentPath, menuPath, exact = false, otherActivePaths = []) => {

    if (exact) {
        return currentPath === menuPath;
    }

    // Check if current path matches any of the other active paths
    if (otherActivePaths && otherActivePaths.length > 0) {
        const isOtherPathMatch = otherActivePaths.some(path => {
            if (path.includes('*')) {
                // Convert wildcard pattern to regex
                const pattern = path.replace('*', '.*');
                return new RegExp(`^${pattern}$`).test(currentPath);
            }
            return currentPath === path;
        });

        if (isOtherPathMatch) {
            return true;
        }
    }

    // If no other paths match, check if current path starts with menu path
    return currentPath.startsWith(menuPath);
}; 